<template>
  <div class="container my-5">
    <div class="row justify-content-center" v-if="maintenance">
      <div class="col-10 col-sm-6 col-md-4 col-lg-3">
        <b-img
          style="border: none"
          class="text-center"
          thumbnail
          fluid
          :src="maintenance.logo"
          alt="Maintenance Logo"
        />
      </div>
    </div>
    <div class="row justify-content-center" v-if="maintenance">
      <div class="col-12 col-sm-10 col-md-6">
        <h5
          style="white-space: pre-line;"
          class="text-center"
          v-html="maintenance.description"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Maintenance",
  computed: {
    ...mapState("merchant", {
      maintenance: state => state.maintenance
    })
  },
  async mounted() {
    await this.$store.dispatch("merchant/fetchMerchantMaintenance");
    if (!this.maintenance)
      this.$router.push(`/${this.$route.params.subdomain}`);
  }
};
</script>
